import React from "react";
import "./OrderSuccess.css"
import { useNavigate } from "react-router-dom";


const OrderSuccess = () => {
    const navigate = useNavigate();
    return (
        <div className="order-success">
            <h1 className="title-order-success">Order Successful</h1>
            <p>Your order has been placed successfully!</p>
            <p>You will receive an email shortly containing a chain of custody (COC) form
                and instructions on how to send off your samples for testing.
            </p>
            <p>You can check back <span className="order-success-link" onClick={() => navigate("/LabOrders")} style={{ cursor: "pointer", textDecoration: "underline" }}>here</span> to get updates on your order status</p>
            <button
                className="back-to-dash-button"
                onClick={() => navigate("/Dashboard")}
            > 
                Back to dashboard
            </button>
        </div>
    ); 
};

export default OrderSuccess;
